/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  wsTypeData (plantId) {
    return Api().get(`/api/v1.0/wsType/${plantId}`)
  },
  wsData (param) {
    return Api().post('/api/v1.0/wsGraph', param)
  },
  wsBoxData (param) {
    return Api().post('/api/v1.0/wsBox', param)
  },
  wsRangeBoxData (param) {
    return Api().post('/api/v1.0/wsRangeBox', param)
  },
  // wsBoxDataAll (param) {
  //   return Api().post('/api/v1.0/wsBoxAll', param)
  // },
  // wsRangeBoxDataAll (param) {
  //   return Api().post('/api/v1.0/wsRangeBoxAll', param)
  // },
  wsDataTable (param) {
    return Api().post('/api/v1.0/wsTable', param)
  },
  wsDataTableAll (param) {
    return Api().post('/api/v1.0/wsTable/group', param)
  },
  wsList (plantId) {
    return Api().get('/api/v1.0/ws-config/' + plantId)
  }
}
